'use client';

import ErrorScreen from '@/components/layout/ErrorScreen';

const Error = ({ error }) => <ErrorScreen error={error} />;

export default Error;
